"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _base = babelHelpers.interopRequireDefault(require("block/base"));

var _react = babelHelpers.interopRequireDefault(require("react"));

var _decorators = require("decorators");

var _classList = babelHelpers.interopRequireDefault(require("class-list"));

var _userProfile = require("user-profile");

var _LoginForm = require("components/LoginForm");

var _eventDispatcher = babelHelpers.interopRequireDefault(require("event-dispatcher"));

var _VideoPlayer = babelHelpers.interopRequireDefault(require("VideoPlayer"));

var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _temp;

var VideoBlock = (_class = (_temp =
/*#__PURE__*/
function (_Block) {
  babelHelpers.inherits(VideoBlock, _Block);

  function VideoBlock() {
    var _babelHelpers$getProt;

    var _this;

    babelHelpers.classCallCheck(this, VideoBlock);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = babelHelpers.possibleConstructorReturn(this, (_babelHelpers$getProt = babelHelpers.getPrototypeOf(VideoBlock)).call.apply(_babelHelpers$getProt, [this].concat(args)));
    babelHelpers.initializerDefineProperty(_this, "videoProps", _descriptor, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this)));
    babelHelpers.initializerDefineProperty(_this, "hasVideo", _descriptor2, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this)));
    babelHelpers.initializerDefineProperty(_this, "videoInModal", _descriptor3, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this)));
    babelHelpers.initializerDefineProperty(_this, "name", _descriptor4, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this)));
    babelHelpers.initializerDefineProperty(_this, "summary", _descriptor5, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this)));
    return _this;
  }

  babelHelpers.createClass(VideoBlock, [{
    key: "getChildren",
    value: function getChildren() {
      return _react.default.createElement("div", {
        className: "inner-content"
      }, _react.default.createElement("div", {
        className: "container"
      }, this.hasVideo && this.videoInModal && _react.default.createElement(_VideoPlayer.default, {
        lazy: this.videoProps
      }), _react.default.createElement("h1", null, this.name), this.hasVideo && !this.videoInModal && _react.default.createElement(_VideoPlayer.default, {
        lazy: this.videoProps
      }), this.summary && _react.default.createElement("h2", {
        style: {
          whiteSpace: 'pre-wrap'
        }
      }, this.summary)));
    }
  }]);
  return VideoBlock;
}(_base.default), _temp), (_descriptor = babelHelpers.applyDecoratedDescriptor(_class.prototype, "videoProps", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = babelHelpers.applyDecoratedDescriptor(_class.prototype, "hasVideo", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = babelHelpers.applyDecoratedDescriptor(_class.prototype, "videoInModal", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = babelHelpers.applyDecoratedDescriptor(_class.prototype, "name", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5 = babelHelpers.applyDecoratedDescriptor(_class.prototype, "summary", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
})), _class);
exports.default = VideoBlock;